import { IApplicationState } from '../../types/redux';

export const getNewbuildingPromoSnippetExtensionFields = (state: IApplicationState) => {
  return state.offersData.newbuildingPromoSnippet?.extensionFields;
};
